function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AppContext } from 'context';
import Loader from 'svg/loader.svg';
import urlRouteShape from 'shapes/urlRouteShape';
import Account from 'modules/Account';
import { AlertsBus } from 'modules/App';
import history from 'helpers/history';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import styles from './ImplicitProfileSetup.pcss';
var _React_PureComponent;
class ImplicitProfileSetup extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.props.onCreateProfile();
    }
    componentDidUpdate(prevProps) {
        const { activeProfileMainUrlRoute, isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            const { name, params } = activeProfileMainUrlRoute;
            const url = this.context.getUrl(name, params);
            history.push(url);
        }
    }
    renderLoader() {
        if (this.props.hasErrors) {
            return 'Has errors';
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.loaderContainer,
            children: /*#__PURE__*/ _jsx(Loader, {
                className: cn(styles.loader, 'rotatingLoader')
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "pageHeader",
                    children: /*#__PURE__*/ _jsx("h1", {
                        className: "text--h1",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.headers.configuringProfile))
                    })
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-5"
                }),
                this.renderLoader()
            ]
        });
    }
}
_define_property(ImplicitProfileSetup, "contextType", AppContext);
_define_property(ImplicitProfileSetup, "propTypes", {
    // Explicit props
    activeProfileType: Account.shapes.profileType,
    // Implicit props
    isInProgress: PropTypes.bool,
    hcpProfile: PropTypes.object,
    activeProfileMainUrlRoute: urlRouteShape,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onCreateProfile: PropTypes.func
});
const mapStateToProps = (state, props)=>{
    const { activeProfileType } = props;
    let isCreateProfileInProgress;
    let hasCreateProfileErrors;
    if (activeProfileType === Account.constants.PROFILE_TYPES.HCP) {
        isCreateProfileInProgress = selectors.isCreateHcpProfileInProgress;
        hasCreateProfileErrors = selectors.hasCreateHcpProfileErrors;
    } else if (activeProfileType === Account.constants.PROFILE_TYPES.CG) {
        isCreateProfileInProgress = selectors.isCreateCgProfileInProgress;
        hasCreateProfileErrors = selectors.hasCreateCgProfileErrors;
    }
    return {
        isInProgress: isCreateProfileInProgress(state) || Account.selectors.isValidateMembershipInProgress(state),
        hcpProfile: Account.selectors.hcpProfile(state),
        activeProfileMainUrlRoute: Account.selectors.activeProfileMainUrlRoute(state),
        hasErrors: hasCreateProfileErrors(state)
    };
};
const mapDispatchToProps = (dispatch, props)=>{
    const { activeProfileType } = props;
    let createProfile;
    if (activeProfileType === Account.constants.PROFILE_TYPES.HCP) {
        createProfile = actions.createHcpProfile;
    } else if (activeProfileType === Account.constants.PROFILE_TYPES.CG) {
        createProfile = actions.createCgProfile;
    }
    return {
        onCreateProfile: ()=>dispatch(createProfile())
    };
};
const ConnectedImplicitProfileSetup = connect(mapStateToProps, mapDispatchToProps)(ImplicitProfileSetup);
export default withStyles(styles)(ConnectedImplicitProfileSetup);
